import { createMuiTheme, Theme } from '@material-ui/core';
import { Overrides } from '@material-ui/core/styles/overrides';

const muiPickerOverrides = {
  MuiPickersDay: {
    current: {
      color: '#1A1A1A',
      border: 'solid 1px #1A1A1A',
    },
  },
};

const palette = {
  primary: {
    light: '#FFE4CC',
    main: '#FF7800',
    dark: '#FF964D',
    contrastText: '#fff',
  },
  secondary: {
    light: '#45476D6E',
    main: '#1B2042',
    dark: '#45476D',
  },
  error: {
    main: '#FF1D15',
  },
  success: {
    main: '#00BF4C',
  },
  warning: {
    main: '#FFA07A',
  },
  text: {
    primary: '#1A1A1A',
    secondary: '#000000',
  },
  grey: {
    100: '#F0F0F0',
    200: '#F6F6F6',
    400: '#C4C4C4',
    500: '#D8D8D8',
    600: '#B6B6B6',
    900: '#444444',
  },
  common: {
    white: '#fff',
  },
};

export const theme: Theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette,
  typography: {
    fontFamily: 'Poppins',
    fontSize: 16,
    h1: {
      fontFamily: 'Poppins',
      fontWeight: 'bold',
      fontSize: 68,
    },
    h2: {
      fontFamily: 'Poppins',
      fontWeight: 700,
      fontSize: 28,
      color: '#F15A24',
    },
    h3: {
      fontFamily: 'Poppins',
      fontWeight: 700,
      fontSize: 20,
      color: '#F15A24',
    },
    h4: {
      fontFamily: 'Poppins',
      fontSize: '18px',
      lineHeight: '27px',
      fontWeight: 700,
    },
    body1: {
      fontSize: 15,
      lineHeight: 1.8,
    },
    body2: {
      fontSize: '14px',
      lineHeight: '18.2px',
    },
    button: {
      fontFamily: 'Poppins',
      fontSize: 16,
      lineHeight: 1.8,
      textTransform: 'uppercase',
    },
    subtitle2: {
      color: '#b6b6b6',
      fontFamily: 'Poppins',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '21px',
      letterSpacing: 0,
      textAlign: 'left',
    },
  },
  props: {
    MuiButton: {
      disableElevation: true,
      color: 'primary',
      variant: 'contained',
      size: 'medium',
    },
  },
});

export const muiButtonOverrides: Overrides = {
  MuiButton: {
    root: {
      marginRight: '8px',
      borderRadius: 0,
    },
    contained: {
      color: theme.palette.common.white,
    },
    containedPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    containedSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
    },
    outlined: {
      backgroundColor: 'white',
    },
    outlinedPrimary: {
      '&:hover': {
        backgroundColor: theme.palette.primary.light,
      },
    },
    outlinedSecondary: {
      '&:hover': {
        backgroundColor: theme.palette.secondary.light,
      },
    },
    sizeSmall: {
      fontSize: 16,
      lineHeight: '25px',
    },
    sizeLarge: {
      fontSize: 25,
      lineHeight: '40px',
    },
  },
};

const overrides = {
  ...muiPickerOverrides,
  ...muiButtonOverrides,
  MuiChip: {
    root: {
      fontSize: 13,
      lineHeight: 1.39,
      fontWeight: 400,
      fontFamily: 'Poppins',
    },
    deleteIcon: {
      width: '14px',
      marginRight: '8px',
    },
    deleteIconSmall: {
      width: '9px',
      marginRight: '4px',
    },
  },
};

theme.overrides = overrides;
